import { jsx as c } from "react/jsx-runtime";
import { c as w } from "../../../clsx-OuTLNxxd.js";
const d = "_flex_10u4m_29", x = "_wrap_10u4m_67", h = "_nowrap_10u4m_70", _ = {
  flex: d,
  "flex-row": "_flex-row_10u4m_34",
  "flex-column": "_flex-column_10u4m_37",
  "justify-start": "_justify-start_10u4m_40",
  "justify-end": "_justify-end_10u4m_43",
  "justify-center": "_justify-center_10u4m_46",
  "justify-space-between": "_justify-space-between_10u4m_49",
  "justify-space-around": "_justify-space-around_10u4m_52",
  "align-start": "_align-start_10u4m_55",
  "align-end": "_align-end_10u4m_58",
  "align-center": "_align-center_10u4m_61",
  "align-stretch": "_align-stretch_10u4m_64",
  wrap: x,
  nowrap: h,
  "wrap-reverse": "_wrap-reverse_10u4m_73",
  "is-full-width": "_is-full-width_10u4m_79",
  "is-full-height": "_is-full-height_10u4m_82",
  "flex-grow": "_flex-grow_10u4m_85",
  "gap-0": "_gap-0_10u4m_88",
  "gap-1": "_gap-1_10u4m_91",
  "gap-2": "_gap-2_10u4m_94",
  "gap-3": "_gap-3_10u4m_97",
  "gap-4": "_gap-4_10u4m_100",
  "gap-5": "_gap-5_10u4m_103",
  "gap-6": "_gap-6_10u4m_106",
  "gap-7": "_gap-7_10u4m_109",
  "gap-8": "_gap-8_10u4m_112",
  "gap-9": "_gap-9_10u4m_115",
  "gap-10": "_gap-10_10u4m_118",
  "gap-11": "_gap-11_10u4m_121",
  "gap-12": "_gap-12_10u4m_124",
  "gap-14": "_gap-14_10u4m_127",
  "gap-16": "_gap-16_10u4m_130",
  "gap-18": "_gap-18_10u4m_133",
  "gap-20": "_gap-20_10u4m_136",
  "gap-24": "_gap-24_10u4m_139",
  "gap-28": "_gap-28_10u4m_142",
  "gap-32": "_gap-32_10u4m_145",
  "gap-36": "_gap-36_10u4m_148",
  "gap-40": "_gap-40_10u4m_151",
  "gap-44": "_gap-44_10u4m_154",
  "gap-48": "_gap-48_10u4m_157",
  "gap-52": "_gap-52_10u4m_160",
  "gap-56": "_gap-56_10u4m_163",
  "gap-60": "_gap-60_10u4m_166",
  "gap-64": "_gap-64_10u4m_169",
  "gap-72": "_gap-72_10u4m_172",
  "gap-80": "_gap-80_10u4m_175",
  "gap-96": "_gap-96_10u4m_178",
  "no-margin": "_no-margin_10u4m_181",
  "dialog-overlay-show": "_dialog-overlay-show_10u4m_1",
  "dialog-content-show": "_dialog-content-show_10u4m_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_10u4m_1"
};
function v({
  children: g,
  direction: p = "row",
  justifyContent: u = "start",
  alignItems: e = "start",
  flexWrap: m = "wrap",
  className: t = "",
  isFullWidth: s = !1,
  isFullHeight: l = !1,
  gap: a,
  style: n,
  noMargin: i = !1,
  flexGrow: r = !1,
  ...o
}) {
  const f = w(
    _.flex,
    _[`flex-${p}`],
    _[`justify-${u}`],
    _[`align-${e}`],
    _[m],
    s && _["is-full-width"],
    l && _["is-full-height"],
    a && _[`gap-${a}`],
    i && _["no-margin"],
    r && _["flex-grow"],
    t
  );
  return /* @__PURE__ */ c("div", { className: f, ...o, style: n, children: g });
}
export {
  v as Flex
};
